import { render, staticRenderFns } from "./Property.vue?vue&type=template&id=61873ecb"
import script from "./Property.vue?vue&type=script&lang=ts"
export * from "./Property.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports